export default __webpack_public_path__ + "static/media/COPPADisclosure.e84b339c.pdf";